module.exports = __webpack_public_path__ + "static/media/profile2.1e4d46bc.jpg";